export default __webpack_public_path__ + "static/media/animated-chonky.b79de283.gif";